import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '5px',
    width: '100%',
    fontSize: '1.6rem',
    '& ol': {
      listStyleType: 'upper-roman',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '2rem',
      '& div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '1rem',
        padding: '1rem',
        width: '100%',
        fontSize: '1.45rem',
      },
      '& li': {
        textAlign: 'justify',
      },
    },
  },
  
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
  },
}))

export default styles
